import { AppRouter } from './router.js';

export function App(): JSX.Element {
  return <AppRouter />;
}
